export function Loader() {
  return (
    <div className="min-h-[200px] flex flex-col items-center justify-center gap-2">
      <div className="relative">
        <div className="h-32 w-32 rounded-full border-4 border-customPurple-100"></div>
        <div className="absolute top-0 left-0 h-32 w-32 rounded-full border-4 border-t-customPurple-500 animate-spin"></div>
      </div>
      <p className="text-sm text-muted-foreground">Загружаем...</p>
    </div>
  );
}
